import type { TFilterField, FilterValue } from '@/types/api/reports'
import { startOfDay, endOfDay } from 'date-fns'

export type TFilterEmitValue = {
  field: TFilterField
  value: FilterValue
  is_active: boolean
}

export const addTimeToDate = ({ date_from, date_to }: { date_from: string; date_to: string }) => ({
  date_from: startOfDay(new Date(date_from)).toISOString(),
  date_to: endOfDay(new Date(date_to)).toISOString(),
})
